import { Button, CircularProgress, type ButtonProps } from '@mui/material';
import DownloadIcon from '@mui/icons-material/GetApp';
import { useState } from 'react';

interface Props extends ButtonProps {
  promise: () => Promise<void>
  icon?: JSX.Element
}

function LoadingButton({ promise, children, icon = <DownloadIcon className='mr-1' fontSize='small' />,  ...buttonProps }: Props) {
  const [loading, setLoading] = useState<boolean>(false)
  async function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    setLoading(true)
    return await promise().finally(()=> setLoading(false))
  }

  return <Button {...buttonProps} size='small' disabled={loading} onClick={handleClick}>
    {loading ? <CircularProgress size={12} color='secondary' className='mr-2 mb-1' /> : icon}
    {children}
  </Button>

}

export default LoadingButton